// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"bc2843c3","113":"8397037b","453":"9ba7c08b","482":"2df1a1a7","606":"48fb9f3b","677":"bf8ee6da","776":"924c7330","800":"c83c9316","953":"f41f7037","954":"1b180607","977":"7c730d56","986":"ad2c6c61"}[chunkId] + ".chunk.js";
};